module.exports = __webpack_public_path__ + "static/media/People.86c4d394.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/People.svg
// module id = 1122
// module chunks = 0